
import React, { useEffect, useRef, useState } from "react";
import "./configurationDashboardSidebar.css"
import { Sidebar, Menu, MenuItem, useProSidebar } from 'react-pro-sidebar';
import { faCircleChevronRight, faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Switch from "react-switch";
import {useSelector} from 'react-redux';
import { SidebarOptions } from "../../types";
import store from "../../stateManagement/store";
import { setActiveSidebar } from "../../stateManagement/actions/configDashboardActions";
import { Link, useNavigate } from "react-router-dom";
import RenderSvg from "../renderSvg/RenderSvg";
import { useTranslation } from 'react-i18next';
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { Autocomplete, TextField } from "@mui/material";
import { AppOptionType, OptionType } from "../../features/manageHomepage/ManageHomePageTypes";
import { doFinalConfigSubmit, getMetaDataConfig, setAppAndRoleOptions } from "../../services/uiConfigService";
import Loader from "../loading/Loader";
import { setCurrentAppType, setCurrentRole } from "../../stateManagement/actions/roleActions";
import { removeFromSessionStorage } from "../dms_common/DmsUtils";

export function ConfigurationDashboardSidebar() {
    const { translate } = usePortalTranslation();
    const { t } = useTranslation();
    let adminPanelOptionsConfig = store.getState()?.portalConfigState?.layoutConfig?.find((configObj) => configObj.name === "adminPanelLayout")?.value ?? [];
    const { collapseSidebar, collapsed } = useProSidebar();
    const navigate = useNavigate();
    const configDashboardTypes = store.getState().configTypeState?.configDashboardTypes;
    const configActiveOption = store.getState().configTypeState?.activeOption;
    const selectedConfigType = configDashboardTypes.find(config=> config.id === configActiveOption);

    const sidebarOptions:SidebarOptions[] = useSelector(() => store.getState().sidebarState.visibleSidebarOptions)
    const activeOption:string = useSelector(() => store.getState().sidebarState.activeOption)
    const clientConfigRef = useRef<any[]>([]);
    const [roleOptions, setRoleOptions] = useState<OptionType[]>([]);
    const [appTypeOptions, setAppTypeOptions] = useState<AppOptionType[]>([]);
    const savedAppType:any = useSelector(() => store.getState().appTypeState.appType)
    const savedRole:any = useSelector(() => store.getState().roleState.role) ?? savedAppType?.designations?.[0];
    const [loading,setLoading] = useState<boolean>(false);
    async function setRole(){
        try{
            setLoading(true);
            let clientConfig;
            if(clientConfigRef?.current?.length>0){
                clientConfig = clientConfigRef.current
            }else{
                clientConfig = await getMetaDataConfig("clientconfig");
            }
            const resp = setAppAndRoleOptions({
                setAppTypeOptions: setAppTypeOptions,
                setRoleOptions: setRoleOptions,
                clientConfig: clientConfig,
                savedRole: savedRole
            });
        }catch(err){
            console.error("error occured while setting role initially ");
        }finally{
            setLoading(false);
        }
    }
    useEffect(() => {
        if(selectedConfigType && selectedConfigType.id==="Salescode Studio"){
            setRole()
        }
    },[selectedConfigType?.id])   

    const handleSidebarOnClick = (id: string, route: string) => {
        removeFromSessionStorage()
        setActiveSidebar(id);
        navigate(route);
    }
    const handleKeyPress = (
        e: React.KeyboardEvent<HTMLElement>, 
        id: string,
        route: string
      ) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); 
          handleSidebarOnClick(id, route);
        }
      };
      

    store.dispatch({
      type: "toggleSidebarCollapsed",
      payload: { sidebarCollapsed: collapsed },
    });


    return (
        <>
            <Sidebar width="14%" backgroundColor="#ffffff" className="sidebar_container" collapsedWidth="78px">
            <div className="sidebar_body" style={{
                    overflowY: "hidden",
                    height: "100%", display: "flex",
                    flexDirection: "column",
                }}>
                    {loading ? (
                        <Loader/>
                        ) : (
                        <>
                            {((selectedConfigType && selectedConfigType.id !== "Salescode Studio") ||
                            (selectedConfigType &&
                                selectedConfigType.id === "Salescode Studio" &&
                                roleOptions?.length < 1)) && (
                            <Menu style={{ backgroundColor: "#f3fcfb", flex: "0 0 auto" }}>
                                <MenuItem
                                className="sidebar-header-container"
                                disabled={true}
                                style={{ padding: "0px 16px 0px 16px" }}
                                >
                                <div className="sidebarHeader">
                                    <div
                                    className="sidebar-header-switch"
                                    onClick={() => {
                                        collapseSidebar();
                                    }}
                                    >
                                    <Switch
                                        onChange={() => {}}
                                        checked={!collapsed}
                                        offColor="#909090"
                                        onColor="#24c6b1"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        height={23}
                                        width={44}
                                    />
                                    </div>
                                    {!collapsed && (
                                    <div className="sidebar-header-label">
                                        {selectedConfigType
                                        ? translate(TranslationEnum.sidebar_options, selectedConfigType.label)
                                        : "Salescode"}
                                    </div>
                                    )}
                                </div>
                                </MenuItem>
                            </Menu>
                            )}

                            {selectedConfigType &&
                            selectedConfigType.id === "Salescode Studio" &&
                            appTypeOptions?.length > 1 && (
                                <div style={{ backgroundColor: "#f3fcfb", padding: "10px" }}>
                                <p style={{ color: "#909090", fontSize: "14px", marginBottom: "1em" }}>
                                    App Type Selected:
                                </p>
                                <Autocomplete
                                    disableClearable
                                    options={appTypeOptions}
                                    getOptionLabel={(option) => option.label}
                                    value={
                                    appTypeOptions.find(
                                        (appType) => appType?.id === savedAppType?.id
                                    ) || undefined
                                    }
                                    onChange={async (event, newValue) => {
                                    setCurrentAppType(newValue || undefined);
                                    setRoleOptions(newValue?.designations || undefined);
                                    // only change role if it is not the same as the saved role
                                    if(newValue?.designations?.[0]?.id !== savedRole?.id){
                                        setCurrentRole(newValue?.designations?.[0] || undefined);
                                    }
                                    await doFinalConfigSubmit("playground_config", []);
                                    }}
                                    renderInput={(params) => (
                                    <TextField
                                        sx={{
                                        "& .MuiInputBase-root": {
                                            fontSize: "14px",
                                        },
                                        "& .MuiFormLabel-root": {
                                            fontSize: "14px",
                                            marginTop: "-4px",
                                            "&.MuiInputLabel-shrink": {
                                            marginTop: "0",
                                            },
                                        },
                                        }}
                                        {...params}
                                        label="Select App Type"
                                        variant="outlined"
                                    />
                                    )}
                                    sx={{
                                    "& .MuiAutocomplete-inputRoot": {
                                        padding: "4px",
                                    },
                                    }}
                                />
                                </div>
                            )}

                            {selectedConfigType &&
                            selectedConfigType.id === "Salescode Studio" &&
                            roleOptions?.length > 1 && (
                                <div style={{ backgroundColor: "#f3fcfb", padding: "10px" }}>
                                <p style={{ color: "#909090", fontSize: "14px", marginBottom: "1em" }}>
                                    Designation Selected:
                                </p>
                                <Autocomplete
                                    disableClearable
                                    options={roleOptions}
                                    getOptionLabel={(option) => option.label}
                                    value={
                                    roleOptions.find((role) => role.id === savedRole.id) || undefined
                                    }
                                    onChange={async (event, newValue) => {
                                        // only change role if it is not the same as the saved role
                                        if(newValue?.id !== savedRole?.id){
                                            setCurrentRole(newValue || undefined);
                                        }
                                    await doFinalConfigSubmit("playground_config", []);
                                    }}
                                    renderInput={(params) => (
                                    <TextField
                                        sx={{
                                        "& .MuiInputBase-root": {
                                            fontSize: "14px",
                                        },
                                        "& .MuiFormLabel-root": {
                                            fontSize: "14px",
                                            marginTop: "-4px",
                                            "&.MuiInputLabel-shrink": {
                                            marginTop: "0",
                                            },
                                        },
                                        }}
                                        {...params}
                                        label="Select Designation"
                                        variant="outlined"
                                    />
                                    )}
                                    sx={{
                                    "& .MuiAutocomplete-inputRoot": {
                                        padding: "4px",
                                    },
                                    }}
                                />
                                </div>
                            )}
                        </>
                        )}

                <Menu style={{flex: "1 1 auto", overflow:"auto"}} menuItemStyles={{
                    button: ({ active }) => {
                        // only apply styles on first level elements of the tree
                        const commonCSS = {
                            fontSize: "14px",
                            margin:"10px",
                            padding:"0 10px 0 10px",
                            height:"fit-content"
                        }
                        if (active) {
                            return {
                                ...commonCSS,
                                color: 'var(--dashboard-theme-color)',
                                fontWeight: 500,
                                backgroundColor: "#f3fcfb",
                                border:"2px solid var(--dashboard-theme-color)",
                                borderRadius:"5px"
                            }
                        } else {
                            return {
                                ...commonCSS,
                                color: '#909090',
                                backgroundColor: "#ffffff"
                            }
                        }

                    }
                }}>
                    {sidebarOptions.map((sidebarObject) => (
                        <MenuItem
                            className={`sidebar-menu-item  ${sidebarObject.externalFeature? "navbar-redirection-card" : ""}`}
                            key={sidebarObject.id}
                            tabIndex={0}
                            active={sidebarObject.id === activeOption}
                            onKeyDown={(e) => handleKeyPress(e, sidebarObject.id, sidebarObject.route)}
                            onClick={() => { handleSidebarOnClick(sidebarObject.id, sidebarObject.route) }}
                            icon={<RenderSvg color={sidebarObject.id==="googleAnalytics"? "#1c7ea0" : "#909090"} name={sidebarObject.icon} />}
                        >
                            {translate(TranslationEnum.sidebar_options,sidebarObject.label)}
                        </MenuItem>
                    ))}
                </Menu>
                <Menu style={{ fontFamily: "Poppins, sans-serif", fontWeight: "lighter", flex: "0 0 auto"}} menuItemStyles={{
                    button: {
                        fontSize: "15px",
                        margin:"10px",
                        padding:"0 10px 0 10px",
                        height:"fit-content",
                        border: "2px solid transparent",
                        borderRadius: "5px",
                        '&:hover': {
                            border: "2px solid var(--dashboard-theme-color)"
                        }
                    }
                }}>
                   {adminPanelOptionsConfig.length ? <MenuItem
                        className="configuration-dashboard-sidebar-footer"
                        tabIndex={0}
                        onClick={() => navigate("/dashboard/adminPanel")}
                        onKeyDown={(e) => handleKeyPress(e, "", "/dashboard/adminPanel")}
                        icon={<div className="sidebar-footer-icon-container"><RenderSvg name="configIcon" /></div>}
                    >
                        <div>{translate(TranslationEnum.sidebar_options,"ADMIN PANEL")}</div>
                    </MenuItem>
                    : <></>}
                </Menu>
                </div>
            </Sidebar>
            <main className="collapseButton">
                {collapsed ?
                    <FontAwesomeIcon onClick={() => collapseSidebar()} icon={faCircleChevronRight} /> :
                    <FontAwesomeIcon onClick={() => collapseSidebar()} icon={faChevronCircleLeft} />
                }
            </main>
        </>
    );
}
